import React from 'react';
import { CustomIcon } from './CustomIcon';
export const Visualization = () => {
  return <section className="py-16 bg-teal-50" data-id="element-345">
      <div className="container mx-auto px-4" data-id="element-346">
        <div className="text-center mb-12" data-id="element-347">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-348">
            Cierra los ojos un momento…
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-349">
            Y escucha con el cuerpo:
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-350">
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-351">
            <div className="bg-teal-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-4 mx-auto" data-id="element-352">
              <CustomIcon name="credit-card" size={28} className="text-teal-600" data-id="element-353" />
            </div>
            <h3 className="text-xl font-bold text-center text-gray-800 mb-3" data-id="element-354">
              Sin Miedo al Banco
            </h3>
            <p className="text-gray-600 text-center" data-id="element-355">
              Abres tu app de banco y, por primera vez, no hay miedo. Hay
              ahorro.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-356">
            <div className="bg-teal-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-4 mx-auto" data-id="element-357">
              <CustomIcon name="trending-down" size={28} className="text-teal-600" data-id="element-358" />
            </div>
            <h3 className="text-xl font-bold text-center text-gray-800 mb-3" data-id="element-359">
              Deudas Controladas
            </h3>
            <p className="text-gray-600 text-center" data-id="element-360">
              Tus deudas bajan constantemente siguiendo un plan realista.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-361">
            <div className="bg-teal-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-4 mx-auto" data-id="element-362">
              <CustomIcon name="arrow-up" size={28} className="text-teal-600" data-id="element-363" />
            </div>
            <h3 className="text-xl font-bold text-center text-gray-800 mb-3" data-id="element-364">
              Decisiones Tuyas
            </h3>
            <p className="text-gray-600 text-center" data-id="element-365">
              Tus decisiones son tuyas, basadas en conocimiento real y
              contextualizado.
            </p>
          </div>
          <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-366">
            <div className="bg-teal-100 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-4 mx-auto" data-id="element-367">
              <CustomIcon name="brain" size={28} className="text-teal-600" data-id="element-368" />
            </div>
            <h3 className="text-xl font-bold text-center text-gray-800 mb-3" data-id="element-369">
              Liviano y en Control
            </h3>
            <p className="text-gray-600 text-center" data-id="element-370">
              Te sientes liviano, en control. No porque ganas más, sino porque
              juegas con reglas reales.
            </p>
          </div>
        </div>
        <div className="mt-12 text-center" data-id="element-371">
          <p className="text-xl italic text-gray-700" data-id="element-372">
            "Algo dentro de ti ya sabe que este es el cambio que esperabas."
          </p>
        </div>
        <div className="mt-16 flex justify-center" data-id="element-373">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/mhVHTsaFFt4ahL2MmMMkcQ/portada_inicio_financiero.png" alt="Tu Nuevo Inicio Financiero" className="w-full max-w-sm rounded-lg shadow-2xl" data-id="element-374" />
        </div>
      </div>
    </section>;
};